import React from 'react';
import SidebarLayout from './SidebarLayout';

const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const items = [
    { label: 'Overview', to: '/admin', end: true },
    { label: 'Products', to: '/admin/products' },
    { label: 'Orders', to: '/admin/orders' },
    { label: 'Wallets', to: '/admin/wallets' },
    { label: 'Support Chats', to: '/admin/chats' },
    { label: 'Membership Plans', to: '/admin/membership-plans' },
  ];

  return (
    <SidebarLayout
      title="Admin"
      subtitle="Manage club operations"
      items={items}
    >
      {children}
    </SidebarLayout>
  );
};

export default AdminLayout;
